<div class="d-none d-md-block d-lg-block d-xl-block d-xxl-block">
  <a href="tel:08008801900" target="_blank" class="text-decoration-none" (click)="onPhoneButtonClick()">
    <div class="box-phone">
      <span class="material-icons"> local_phone </span>
        <div class="box-text-phone">
          <span>Central de Atendimento</span>
          <p>{{ textPhone }}</p>
        </div>
    </div>
  </a>
</div>

<div class="d-md-none d-lg-none d-xl-none">
  <div class="boxBtnContact align-items-center justify-content-center text-center">
    <a href="tel:08008801900" target="_blank" class="text-center text-underline" (click)="onPhoneButtonClick()"><span class="material-icons me-10 align-middle">phone</span>{{  textBtnSac }}</a>
  </div>
</div>